"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BP = void 0;
/* eslint-disable no-console */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-useless-escape */

const BP = function () {
  // let _configuration = loadConfiguration()
  let _configuration;
  const _fieldNames = [
  // Dados da transação
  'bpmpi_transaction_mode',
  // Dados da loja (merchant)
  'bpmpi_merchant_url', 'bpmpi_merchant_newcustomer',
  // Dados de checkout
  'bpmpi_ordernumber', 'bpmpi_currency', 'bpmpi_totalamount', 'bpmpi_paymentmethod', 'bpmpi_installments',
  // Dados de Cartão
  'bpmpi_cardnumber', 'bpmpi_cardexpirationmonth', 'bpmpi_cardexpirationyear', 'bpmpi_cardalias', 'bpmpi_default_card', 'bpmpi_cardaddeddate',
  // Dados de Giftcard
  'bpmpi_giftcard_amount', 'bpmpi_giftcard_currency',
  // Dados de cobrança
  'bpmpi_billto_customerid', 'bpmpi_billto_contactname', 'bpmpi_billto_email', 'bpmpi_billto_street1', 'bpmpi_billto_street2', 'bpmpi_billto_city', 'bpmpi_billto_state', 'bpmpi_billto_zipcode', 'bpmpi_billto_phonenumber', 'bpmpi_billto_country',
  // Dados de entrega
  'bpmpi_shipto_sameasbillto', 'bpmpi_shipto_addressee', 'bpmpi_shipto_email', 'bpmpi_shipto_street1', 'bpmpi_shipto_street2', 'bpmpi_shipto_city', 'bpmpi_shipto_state', 'bpmpi_shipto_zipcode', 'bpmpi_shipto_shippingmethod', 'bpmpi_shipto_phonenumber', 'bpmpi_shipto_firstusagedate', 'bpmpi_shipto_country',
  // Dados do device
  'bpmpi_device_ipaddress', 'bpmpi_device_#_fingerprint', 'bpmpi_device_#_provider', 'bpmpi_device_channel',
  // Dados do carrinho
  'bpmpi_cart_#_name', 'bpmpi_cart_#_description', 'bpmpi_cart_#_sku', 'bpmpi_cart_#_quantity', 'bpmpi_cart_#_unitprice',
  // Dados do pedido
  'bpmpi_order_recurrence', 'bpmpi_order_productcode', 'bpmpi_order_countlast24hours', 'bpmpi_order_countlast6months', 'bpmpi_order_countlast1year', 'bpmpi_order_cardattemptslast24hours', 'bpmpi_order_marketingoptin', 'bpmpi_order_marketingsource',
  // Dados do usuário/conta
  'bpmpi_useraccount_guest', 'bpmpi_useraccount_createddate', 'bpmpi_useraccount_changeddate', 'bpmpi_useraccount_passwordchangeddate', 'bpmpi_useraccount_authenticationmethod', 'bpmpi_useraccount_authenticationprotocol', 'bpmpi_useraccount_authenticationtimestamp',
  // Dados de aérea (coleção de trechos)
  'bpmpi_airline_travelleg_#_carrier', 'bpmpi_airline_travelleg_#_departuredate', 'bpmpi_airline_travelleg_#_origin', 'bpmpi_airline_travelleg_#_destination',
  // Dados de aérea (coleção de passageiros)
  'bpmpi_airline_passenger_#_name', 'bpmpi_airline_passenger_#_ticketprice',
  // Dados de aérea complementares
  'bpmpi_airline_numberofpassengers', 'bpmpi_airline_billto_passportcountry', 'bpmpi_airline_billto_passportnumber',
  // Dados adicionais da loja
  'bpmpi_mdd1', 'bpmpi_mdd2', 'bpmpi_mdd3', 'bpmpi_mdd4', 'bpmpi_mdd5',
  // Dados de autenticação
  'bpmpi_auth_notifyonly', 'bpmpi_auth_suppresschallenge',
  //Dados de desafios
  'bpmpi_challenge_window_size',
  // Dados de recorrencia,
  'bpmpi_recurring_enddate', 'bpmpi_recurring_frequency', 'bpmpi_recurring_originalpurchasedate', 'bpmpi_recurring_type', 'bpmpi_recurring_validationIndicator', 'bpmpi_recurring_maximumAmount', 'bpmpi_recurring_referenceNumber', 'bpmpi_recurring_occurrence', 'bpmpi_recurring_numberOfPayments', 'bpmpi_recurring_amountType',
  // Dados bandeira
  'bpmpi_brand_establishment_code'];
  var _referenceId = null;
  var _version = null;
  var _lastError = {
    Number: null,
    Description: null,
    HasError: function () {
      return this.Number !== null;
    }
  };
  var _loaded = false;
  function canReadField(fieldName) {
    return document.getElementsByClassName(fieldName).length > 0;
  }
  function readField(fieldName) {
    if (canReadField(fieldName)) return document.getElementsByClassName(fieldName)[0].value;
    return null;
  }
  function readFieldOrDefault(fieldName, defaultValue) {
    if (canReadField(fieldName)) return document.getElementsByClassName(fieldName)[0].value;
    return defaultValue;
  }
  function formatFieldName(fieldName) {
    return fieldName.replace('bpmpi_', '').replace(/\_/g, '');
  }
  function isEnumerableField(fieldName) {
    return /\#/.test(fieldName);
  }
  function getEnumerableFieldName(fieldName, index) {
    return fieldName.replace(/\#/, index);
  }
  function getEnumerableFields(fieldName) {
    const formattedField = formatFieldName(fieldName);
    const parts = formattedField.split('#');
    return {
      enumerable: parts[0],
      field: parts[1]
    };
  }
  function getBrowserInfo() {
    const screenWidth = window && window.screen ? window.screen.width : '';
    const screenHeight = window && window.screen ? window.screen.height : '';
    const colorDepth = window && window.screen ? window.screen.colorDepth : '';
    const userAgent = window && window.navigator ? window.navigator.userAgent : '';
    const javaEnabled = window && window.navigator && window.navigator.javaEnabled() ? 'Y' : 'N';
    let language = '';
    if (window && window.navigator) {
      language = window.navigator.language ? window.navigator.language : window.navigator.browserLanguage;
    }
    const timeZoneOffset = new Date().getTimezoneOffset();
    const browserInfo = {
      userAgent: userAgent,
      screenWidth: screenWidth,
      screenHeight: screenHeight,
      colorDepth: colorDepth,
      timeZoneOffset: timeZoneOffset,
      language: language,
      javaEnabled: javaEnabled,
      javascriptEnabled: 'Y'
    };
    return browserInfo;
  }
  function getRecurringInfo(data) {
    return {
      type: valueOrNull(data, 'recurringtype'),
      validationIndicator: valueOrNull(data, 'recurringvalidationIndicator'),
      maximumAmount: valueOrNull(data, 'recurringmaximumAmount'),
      referenceNumber: valueOrNull(data, 'recurringreferenceNumber'),
      occurrence: valueOrNull(data, 'recurringoccurrence'),
      numberOfPayments: valueOrNull(data, 'recurringnumberOfPayments'),
      amountType: valueOrNull(data, 'recurringamountType')
    };
  }
  function readAllFields() {
    const data = {};
    for (const fieldIndex in _fieldNames) {
      const fieldName = _fieldNames[fieldIndex];
      if (isEnumerableField(fieldName) === false) {
        const objFieldName = formatFieldName(fieldName);
        var fieldValue = readField(fieldName);
        if (fieldValue) {
          data[objFieldName] = readField(fieldName);
        }
      } else {
        let enumberableFieldIndex = 1;
        let enumerableFieldName = getEnumerableFieldName(fieldName, enumberableFieldIndex);
        while (canReadField(enumerableFieldName)) {
          const enumerableFields = getEnumerableFields(fieldName);
          if (!data[enumerableFields.enumerable]) data[enumerableFields.enumerable] = [];
          fieldValue = readField(enumerableFieldName);
          if (!data[enumerableFields.enumerable][enumberableFieldIndex - 1]) data[enumerableFields.enumerable][enumberableFieldIndex - 1] = {};
          data[enumerableFields.enumerable][enumberableFieldIndex - 1][enumerableFields.field] = fieldValue;
          enumberableFieldIndex++;
          enumerableFieldName = getEnumerableFieldName(fieldName, enumberableFieldIndex);
        }
      }
    }
    data.browserInfo = getBrowserInfo();
    data.RecurringInfo = getRecurringInfo(data);
    return data;
  }
  function loadConfiguration() {
    if (typeof bpmpi_config !== 'undefined') {
      return global['bpmpi_config']();
    }
    return {
      Debug: true,
      Environment: 'PRD'
    };
  }
  function getEnvironment() {
    return _configuration.Environment || 'PRD';
  }
  function getCardinalScriptUri() {
    const environment = getEnvironment();
    const enviroments = {
      TST: 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js',
      SDB: 'https://songbirdstag.cardinalcommerce.com/edge/v1/songbird.js',
      PRD: 'https://songbird.cardinalcommerce.com/edge/v1/songbird.js'
    };
    return enviroments[environment];
  }
  function getInitializationParameters() {
    return {
      orderNumber: readField('bpmpi_ordernumber'),
      currency: readField('bpmpi_currency'),
      amount: readField('bpmpi_totalamount')
    };
  }
  function getMpiAbsoluteUri(relativeUri) {
    const environment = getEnvironment();
    const enviroments = {
      TST: 'https://localhost:44351',
      SDB: 'https://mpisandbox.braspag.com.br',
      PRD: 'https://mpi.braspag.com.br'
    };
    return enviroments[environment] + relativeUri;
  }
  function loadScript(url, callback) {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onreadystatechange = callback;
    script.onload = callback;
    head.appendChild(script);
  }
  function getIsDebug() {
    if (_configuration.Debug !== 'undefined') {
      return _configuration.Debug;
    }
    return false;
  }
  function log() {
    if (getIsDebug()) console.log.apply(null, arguments);
  }
  function getCardinalLogLevel() {
    return getIsDebug() ? 'verbose' : 'off';
  }
  function initialize(token, referenceId) {
    _referenceId = referenceId;
    log('[MPI]', 'Initializing...');
    log('[MPI]', 'Token =', token);
    log('[MPI]', 'ReferenceId =', _referenceId);
    const Cardinal = global['Cardinal'];
    Cardinal.configure({
      timeout: '8000',
      maxRequestRetries: '10',
      logging: {
        level: getCardinalLogLevel()
      }
    });
    Cardinal.setup('init', {
      jwt: token
    });
    Cardinal.on('payments.setupComplete', function (data) {
      log('[MPI]', 'Setup complete.');
      log('[MPI]', 'SetupCompleteData =', data);
      notify('onReady');
    });
    Cardinal.on('payments.validated', function (data) {
      log('[MPI]', 'Payment validated.');
      log('[MPI]', 'ActionCode =', data.ActionCode);
      log('[MPI]', 'Data =', data);
      switch (data.ActionCode) {
        case 'SUCCESS':
        case 'NOACTION':
        case 'FAILURE':
          validate(data.Payment.ProcessorTransactionId);
          break;
        case 'ERROR':
          _lastError.Number = data.ErrorNumber;
          _lastError.Description = data.ErrorDescription;
          if (data.Payment && data.Payment.ProcessorTransactionId) {
            validate(data.Payment.ProcessorTransactionId);
          } else {
            notify('onError', {
              Xid: null,
              Eci: null,
              ReturnCode: _lastError.HasError() ? _lastError.Number : 'MPI901',
              ReturnMessage: _lastError.HasError() ? _lastError.Description : 'Unexpected error',
              ReferenceId: null
            });
          }
          break;
        default:
          _lastError.Number = data.ErrorNumber;
          _lastError.Description = data.ErrorDescription;
          if (data.ErrorDescription === 'Success' && data.Payment && data.Payment.ProcessorTransactionId) {
            validate(data.Payment.ProcessorTransactionId);
          } else {
            notify('onError', {
              Xid: null,
              Eci: null,
              ReturnCode: _lastError.HasError() ? _lastError.Number : 'MPI902',
              ReturnMessage: _lastError.HasError() ? _lastError.Description : 'Unexpected authentication response',
              ReferenceId: null
            });
          }
      }
    });
  }
  function postJsonData(relativeUri, content, successCallback) {
    const jsonRequest = JSON.stringify(content);
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          const jsonResponse = JSON.parse(xmlHttpRequest.responseText);
          successCallback(jsonResponse, this);
        } else {
          const message = getErrorMessage(this.response);
          notify('onError', {
            Xid: null,
            Eci: null,
            ReturnCode: 'MPI900',
            ReturnMessage: 'An error has occurred (' + this.status + ')' + message + '',
            ReferenceId: null
          });
        }
      }
    };
    xmlHttpRequest.open('POST', getMpiAbsoluteUri(relativeUri));
    xmlHttpRequest.setRequestHeader('Content-Type', 'application/json');
    xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + readField('bpmpi_accesstoken'));
    xmlHttpRequest.send(jsonRequest);
  }
  function isAuthEnabled() {
    const authEnabled = readFieldOrDefault('bpmpi_auth', 'true');
    log('[MPI]', 'Authentication Enabled =', authEnabled);
    if (authEnabled === 'false') {
      notify('onDisabled');
      return false;
    }
    return true;
  }
  function loadResources() {
    _configuration = loadConfiguration(); //patch
    log('[MPI]', 'Debug =', getIsDebug());
    log('[MPI]', 'Enviroment =', getEnvironment());
    if (!isAuthEnabled()) return;
    if (_loaded) {
      log('[MPI]', 'Resources already loaded...');
      return;
    }
    log('[MPI]', 'Loading resources...');
    _loaded = true;
    loadScript(getCardinalScriptUri(), function () {
      log('[MPI]', 'Cardinal script loaded.');
      postJsonData('/v2/3ds/init', getInitializationParameters(), function (initialization) {
        initialize(initialization.Token, initialization.ReferenceId);
      });
    });
  }
  function enroll() {
    if (!isAuthEnabled()) return;
    if (!_loaded) {
      log('[MPI]', 'Resources not loaded...');
      return;
    }
    log('[MPI]', 'Enrolling...');
    const Cardinal = global['Cardinal'];
    Cardinal.trigger('accountNumber.update', readField('bpmpi_cardnumber'));
    postJsonData('/v2/3ds/enroll', readAllFields(), function (enrollment) {
      log('[MPI]', 'Enrollment result =', enrollment);
      if (enrollment.Version) {
        _version = enrollment.Version;
      }
      const authentication = enrollment.Authentication;
      switch (enrollment.Status) {
        case 'ENROLLED':
          challenge(enrollment);
          break;
        case 'VALIDATION_NEEDED':
          validate(enrollment.AuthenticationTransactionId);
          break;
        case 'AUTHENTICATION_CHECK_NEEDED':
          checkAuthentication(authentication);
          break;
        case 'NOT_ENROLLED':
          notify('onUnenrolled', {
            Xid: authentication.Xid,
            Eci: authentication.Eci,
            Version: _version,
            ReferenceId: authentication.DirectoryServerTransactionId
          });
          break;
        case 'FAILED':
          notify('onFailure', {
            Xid: authentication.Xid,
            Eci: authentication.Eci || authentication.EciRaw,
            Version: _version,
            ReferenceId: authentication.DirectoryServerTransactionId
          });
          break;
        case 'UNSUPPORTED_BRAND':
          notify('onUnsupportedBrand', {
            Xid: null,
            Eci: null,
            ReturnCode: enrollment.ReturnCode,
            ReturnMessage: enrollment.ReturnMessage,
            ReferenceId: null
          });
          break;
        default:
          notify('onError', {
            Xid: null,
            Eci: null,
            ReturnCode: enrollment.ReturnCode,
            ReturnMessage: enrollment.ReturnMessage,
            ReferenceId: null
          });
      }
    });
  }
  function valueOrNull(data, fieldName) {
    return data[fieldName] || null;
  }
  function buildOrder(authenticationTransactionId) {
    log('[MPI] Building order object...');
    const data = readAllFields();
    const order = {
      OrderDetails: {
        TransactionId: authenticationTransactionId,
        OrderNumber: data['ordernumber'],
        CurrencyCode: valueOrNull(data, 'currency'),
        OrderChannel: data['transactionmode'] || 'S'
      },
      Consumer: {
        Account: {
          AccountNumber: data['cardnumber'],
          ExpirationMonth: data['cardexpirationmonth'],
          ExpirationYear: data['cardexpirationyear']
        },
        Email1: valueOrNull(data, 'shiptoemail'),
        Email2: valueOrNull(data, 'billtoemail'),
        ShippingAddress: {
          FullName: null,
          Address1: null,
          Address2: null,
          City: null,
          State: null,
          PostalCode: null,
          CountryCode: null,
          Phone1: null
        },
        BillingAddress: {
          FullName: valueOrNull(data, 'billtocontactname'),
          Address1: valueOrNull(data, 'billtostreet1'),
          Address2: valueOrNull(data, 'billtostreet2'),
          City: valueOrNull(data, 'billtocity'),
          State: valueOrNull(data, 'billtostate') === null ? null : valueOrNull(data, 'billtostate').toUpperCase(),
          PostalCode: valueOrNull(data, 'billtozipcode'),
          CountryCode: valueOrNull(data, 'billtocountry'),
          Phone1: valueOrNull(data, 'billtophonenumber')
        }
      },
      Cart: []
    };
    if (data['shiptosameasbillto'] === 'true') {
      const billingAddress = order.Consumer.BillingAddress;
      order.Consumer.ShippingAddress.FullName = billingAddress.FullName;
      order.Consumer.ShippingAddress.Address1 = billingAddress.Address1;
      order.Consumer.ShippingAddress.Address2 = billingAddress.Address2;
      order.Consumer.ShippingAddress.City = billingAddress.City;
      order.Consumer.ShippingAddress.State = billingAddress.State;
      order.Consumer.ShippingAddress.PostalCode = billingAddress.PostalCode;
      order.Consumer.ShippingAddress.Phone1 = billingAddress.Phone1;
      order.Consumer.ShippingAddress.CountryCode = billingAddress.CountryCode;
    } else {
      order.Consumer.ShippingAddress.FullName = valueOrNull(data, 'shiptoaddressee');
      order.Consumer.ShippingAddress.Address1 = valueOrNull(data, 'shiptostreet1');
      order.Consumer.ShippingAddress.Address2 = valueOrNull(data, 'shiptostreet2');
      order.Consumer.ShippingAddress.City = valueOrNull(data, 'shiptocity');
      order.Consumer.ShippingAddress.State = valueOrNull(data, 'shiptostate') === null ? null : valueOrNull(data, 'shiptostate').toUpperCase();
      order.Consumer.ShippingAddress.PostalCode = valueOrNull(data, 'shiptozipcode');
      order.Consumer.ShippingAddress.Phone1 = valueOrNull(data, 'shiptophonenumber');
      order.Consumer.ShippingAddress.CountryCode = valueOrNull(data, 'shiptocountry');
    }
    if (data.cart) {
      for (const cartItem in data.cart) {
        order.Cart.push({
          Name: valueOrNull(data.cart[cartItem], 'name'),
          Description: valueOrNull(data.cart[cartItem], 'description'),
          SKU: valueOrNull(data.cart[cartItem], 'sku'),
          Quantity: valueOrNull(data.cart[cartItem], 'quantity'),
          Price: valueOrNull(data.cart[cartItem], 'unitprice')
        });
      }
    }
    log('[MPI] Order object =', order);
    return order;
  }
  function challenge(enrollment) {
    const suppression = readField('bpmpi_auth_suppresschallenge');
    log('[MPI] Suppression enabled = ' + suppression);
    if (suppression === 'true') {
      log('[MPI]', 'Challenge supressed...');
      notify('onChallengeSuppression', {
        Xid: null,
        Eci: null,
        ReturnCode: 'MPI601',
        ReturnMessage: 'Challenge suppressed',
        ReferenceId: null
      });
      return;
    }
    log('[MPI]', 'Showing challenge...');
    const continueData = {
      AcsUrl: enrollment.AcsUrl,
      Payload: enrollment.Pareq,
      TransactionId: enrollment.AuthenticationTransactionId
    };
    const order = buildOrder(enrollment.AuthenticationTransactionId);
    log('[MPI] Continue object =', continueData);
    const Cardinal = global['Cardinal'];
    Cardinal.continue('cca', continueData, order);
  }
  function checkAuthentication(authentication) {
    log('[MPI]', 'Authentication result =', authentication);
    switch (authentication.Status) {
      case 'AUTHENTICATED':
        notify('onSuccess', {
          Cavv: authentication.Cavv,
          Xid: authentication.Xid,
          Eci: authentication.Eci,
          Version: authentication.Version,
          ReferenceId: authentication.DirectoryServerTransactionId
        });
        break;
      case 'UNAVAILABLE':
        notify('onUnenrolled', {
          Cavv: authentication.Cavv,
          Xid: authentication.Xid,
          Eci: authentication.Eci,
          Version: authentication.Version,
          ReferenceId: authentication.DirectoryServerTransactionId
        });
        break;
      case 'FAILED':
        notify('onFailure', {
          Xid: authentication.Xid,
          Eci: authentication.Eci || authentication.EciRaw,
          Version: authentication.Version,
          ReferenceId: authentication.DirectoryServerTransactionId
        });
        break;
      case 'ERROR_OCCURRED':
        notify('onError', {
          Xid: authentication.Xid,
          Eci: authentication.Eci || authentication.EciRaw,
          ReturnCode: authentication.ReturnCode,
          ReturnMessage: authentication.ReturnMessage,
          ReferenceId: authentication.DirectoryServerTransactionId
        });
        break;
      default:
        notify('onError', {
          Xid: authentication.Xid,
          Eci: authentication.Eci || authentication.EciRaw,
          ReturnCode: _lastError.HasError() ? _lastError.Number : authentication.ReturnCode,
          ReturnMessage: _lastError.HasError() ? _lastError.Description : authentication.ReturnMessage,
          ReferenceId: authentication.DirectoryServerTransactionId
        });
    }
  }
  function validate(transactionId) {
    const data = readAllFields();
    data['transactionId'] = transactionId;
    log('[MPI]', 'Validating...');
    postJsonData('/v2/3ds/validate', data, function (validation) {
      checkAuthentication(validation);
    });
  }
  function isSubscribed(eventType) {
    return typeof _configuration[eventType] === 'function';
  }
  function notify(eventType, eventData) {
    log('[MPI]', 'Notifying...');
    log('[MPI]', 'Event type =', eventType);
    log('[MPI]', 'Event data =', eventData || 'None');
    if (isSubscribed(eventType)) {
      _configuration[eventType](eventData);
    }
  }
  function getErrorMessage(error) {
    let responseErrorJson;
    try {
      responseErrorJson = JSON.parse(error);
    } catch (e) {
      responseErrorJson = {};
    }
    if (responseErrorJson.Message !== undefined) {
      return ' - ' + responseErrorJson.Message;
    }
    return '';
  }
  return {
    Mpi: {
      load: function () {
        loadResources();
      },
      authenticate: function () {
        enroll();
      }
    }
  };
};
exports.BP = BP;
const instance = BP();
// bpmpi_load();
var _default = instance;
exports.default = _default;